import { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [registrationEnabled, setRegistrationEnabled] = useState(true);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem('token');

        Promise.allSettled([
            api.get('/auth/settings'),
            token ? api.get('/auth/me') : Promise.resolve(null)
        ])
            .then(([settingsResult, meResult]) => {
                if (settingsResult.status === 'fulfilled') {
                    setRegistrationEnabled(settingsResult.value.data.data.registration_enabled);
                }

                if (meResult.status === 'fulfilled' && meResult.value) {
                    setUser(meResult.value.data.data);
                } else if (token) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('user');
                }
            })
            .finally(() => setLoading(false));
    }, []);

    const login = async (email, password) => {
        const { data } = await api.post('/auth/login', { email, password });
        const { token, user } = data.data;
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(user));
        setUser(user);
        return user;
    };

    const register = async (email, password, full_name) => {
        const { data } = await api.post('/auth/register', { email, password, full_name });
        return data.data;
    };

    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, loading, registrationEnabled, login, register, logout }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth debe usarse dentro de un AuthProvider');
    }
    return context;
}
